import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi, saveAuthSession } from '../services/api';
import '../styles/admin-login.css';

function AdminLoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      const response = await authApi.login({ email, password });
      
      if (response.token && response.user) {
        // Save session to localStorage
        saveAuthSession({
          token: response.token,
          user: response.user,
        });
        
        // Redirect based on role
        if (response.user.role === 'admin') {
          navigate('/admin-dashboard');
        } else if (response.user.role === 'physiotherapist') {
          navigate('/physio-dashboard');
        } else {
          navigate('/');
        }
        
        if (onLogin) onLogin();
      } else {
        setError('Login failed. Please try again.');
      }
    } catch (err) {
      setError(err.message || 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrapper">
      <div className="admin-login-glass-card">
        
        <div className="admin-login-header">
          <div className="admin-login-logo">🧠</div>
          <h1 className="admin-login-title">MentalUP Admin</h1>
          <p className="admin-login-subtitle">Secure access portal for administrators.</p>
        </div>

        <div style={{
          background: 'rgba(102, 126, 234, 0.08)',
          border: '1px solid rgba(102, 126, 234, 0.25)',
          borderRadius: '10px',
          padding: '12px 14px',
          marginBottom: '18px',
          fontSize: '13px',
          color: '#334155',
          textAlign: 'left'
        }}>
          <div style={{ fontWeight: '600', color: '#4338ca', marginBottom: '6px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>🔑 Demo Admin Credentials</span>
            <button 
              type="button" 
              onClick={() => { setEmail('admin@psychmitra.com'); setPassword('admin@123'); }}
              style={{
                background: '#4f46e5',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                padding: '3px 8px',
                fontSize: '11px',
                cursor: 'pointer',
                fontWeight: '500'
              }}
            >
              Auto-fill
            </button>
          </div>
          <div style={{ lineHeight: '1.5' }}>
            <div><strong>Email:</strong> <code>admin@psychmitra.com</code> / <code>admin@mentalup.in</code></div>
            <div><strong>Password:</strong> <code>admin@123</code></div>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <div className="admin-error-msg">{error}</div>}

          <div className="admin-input-group">
            <label htmlFor="adminEmail">Corporate Email</label>
            <input 
              id="adminEmail"
              type="email" 
              className="admin-input-field" 
              placeholder="admin@mentalup.in"
              value={email} 
              onChange={e => setEmail(e.target.value)} 
              required 
            />
          </div>

          <div className="admin-input-group">
            <label htmlFor="adminPassword">Password</label>
            <input 
              id="adminPassword"
              type="password" 
              className="admin-input-field" 
              placeholder="••••••••"
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              required 
            />
          </div>

          <button 
            type="submit" 
            className="admin-login-btn" 
            disabled={loading}
          >
            {loading ? 'Authenticating...' : 'Secure Login'}
          </button>

          <button 
            type="button" 
            className="admin-forgot-link" 
            style={{background: 'none', border: 'none', padding: 0, fontFamily: 'inherit', fontSize: 'inherit', cursor: 'pointer', width: '100%'}}
            onClick={(e) => e.preventDefault()}
          >
            Forgot your credentials?
          </button>
        </form>

      </div>
    </div>
  );
}

export default AdminLoginPage;
